var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('wrapper',[_c('loading-screen',{attrs:{"isActive":_vm.isLoading}},[_c('div',{staticClass:"main-content-wrapper"},[_c('div',{staticClass:"d-flex justify-content-between align-items-center mb-4"},[_c('h4',{staticClass:"me-auto"},[_vm._v("Add Unit Product")])]),_vm._v(" "),_c('product-form',{on:{"submit":_vm.handleSubmitData}})],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-283aeb97","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Catalog/AddCatalogPage.vue
// module id = null
// module chunks = 